import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46cda1b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-pedido-forca-vendas-page" }
const _hoisted_2 = { class: "ui-pedido-forca-vendas" }
const _hoisted_3 = { class: "ui-pedido-toolbar" }
const _hoisted_4 = { class: "ui-toolbar-title" }
const _hoisted_5 = { class: "ui-toolbar-actions" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sim", -1))
const _hoisted_7 = {
  key: 1,
  class: "ui-pedido-content"
}
const _hoisted_8 = { class: "ui-abas-dados-principais" }
const _hoisted_9 = {
  key: 0,
  class: "ui-pedido-form"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-cliente-topo" }, [
  /*#__PURE__*/_createElementVNode("label", null, "CLIENTE")
], -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ui-grid-tres" }
const _hoisted_13 = { class: "ui-campo" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nº Pedido", -1))
const _hoisted_15 = { class: "ui-campo" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Data Pedido", -1))
const _hoisted_17 = { class: "ui-campo" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Status", -1))
const _hoisted_19 = {
  style: {"display":"none"},
  class: "ui-campo ui-cotacao"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Cotação", -1))
const _hoisted_21 = { class: "ui-campo" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Forma Pagamento", -1))
const _hoisted_23 = {
  style: {"display":"none"},
  class: "ui-grid-duas"
}
const _hoisted_24 = { class: "ui-campo" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tipo Operação", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Pré-venda" }, "Pré-venda", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Venda" }, "Venda", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Orçamento" }, "Orçamento", -1))
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "ui-campo" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Forma Pagamento", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "DINHEIRO" }, "DINHEIRO", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "BOL 30/45/60" }, "BOL 30/45/60", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "PIX" }, "PIX", -1))
const _hoisted_36 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  style: {"display":"none"},
  class: "ui-campo"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tabela de Ajuste:", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "TABELA DISTRIBUIDOR" }, "TABELA DISTRIBUIDOR", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "TABELA VAREJO" }, "TABELA VAREJO", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "TABELA ATACADO" }, "TABELA ATACADO", -1))
const _hoisted_42 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = {
  style: {"display":"none"},
  class: "ui-campo"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tipo Retirada", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "A Entregar" }, "A Entregar", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Retirar" }, "Retirar", -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = {
  style: {"display":"none"},
  class: "ui-campo"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tipo Frete", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Nenhum Frete" }, "Nenhum Frete", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "CIF" }, "CIF", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "FOB" }, "FOB", -1))
const _hoisted_53 = [
  _hoisted_50,
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = {
  style: {"display":"none"},
  class: "ui-campo"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Transportadora", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "PRÓPRIA" }, "PRÓPRIA", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "TERCEIRIZADA" }, "TERCEIRIZADA", -1))
const _hoisted_59 = [
  _hoisted_56,
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = {
  style: {"display":"none"},
  class: "ui-campo"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Condição Recebimento", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "À VISTA" }, "À VISTA", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "À PRAZO" }, "À PRAZO", -1))
const _hoisted_65 = [
  _hoisted_62,
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = {
  style: {"display":"none"},
  class: "ui-campo ui-pedido-compra"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nº Pedido Compra Cliente", -1))
const _hoisted_68 = { class: "ui-campo ui-observacoes" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Observações do Pedido", -1))
const _hoisted_70 = ["disabled"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-linha-total-separador" }, null, -1))
const _hoisted_72 = { class: "ui-totalizadores-pedido" }
const _hoisted_73 = { class: "ui-totalizador-card" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Itens", -1))
const _hoisted_75 = { class: "ui-totalizador-card" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Produtos", -1))
const _hoisted_77 = {
  style: {"display":"none"},
  class: "ui-totalizador-card"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Desconto", -1))
const _hoisted_79 = { class: "ui-totalizador-desconto" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "%", -1))
const _hoisted_82 = {
  style: {"display":"none"},
  class: "ui-totalizador-card"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1))
const _hoisted_84 = { class: "ui-totalizador-card ui-totalizador-principal" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total do Pedido", -1))
const _hoisted_86 = {
  key: 1,
  class: "ui-itens-content ui-itens-content-com-totalizador"
}
const _hoisted_87 = { class: "ui-lista-produtos ui-lista-itens-pedido-scroll" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-produto-barra" }, null, -1))
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "ui-produto-nome" }
const _hoisted_91 = { class: "ui-produto-grid" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Código:", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Qtd:", -1))
const _hoisted_94 = { class: "ui-produto-grid" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "P. Unitário R$:", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total R$:", -1))
const _hoisted_97 = {
  key: 0,
  class: "ui-produto-acoes"
}
const _hoisted_98 = ["onClick"]
const _hoisted_99 = { class: "ui-totalizadores-itens-pedido" }
const _hoisted_100 = { class: "ui-totalizador-itens-card" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Itens", -1))
const _hoisted_102 = { class: "ui-totalizador-itens-card" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total Produtos", -1))
const _hoisted_104 = { class: "ui-totalizador-itens-card ui-totalizador-itens-principal" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total do Pedido", -1))
const _hoisted_106 = {
  key: 2,
  class: "ui-itens-content"
}
const _hoisted_107 = { class: "ui-campo" }
const _hoisted_108 = { class: "ant-input-affix-wrapper" }
const _hoisted_109 = { class: "ant-input-prefix" }
const _hoisted_110 = {
  role: "img",
  "aria-label": "user",
  type: "user",
  class: "anticon anticon-user"
}
const _hoisted_111 = { class: "ui-lista-produtos" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-produto-barra" }, null, -1))
const _hoisted_113 = { class: "ui-produto-info" }
const _hoisted_114 = ["onClick"]
const _hoisted_115 = {
  style: {"display":"none"},
  class: "ui-produto-grid"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Estoque:", -1))
const _hoisted_117 = { class: "ui-estoque-negativo" }
const _hoisted_118 = { class: "ui-produto-grid" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Código:", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "P. Unitário R$:", -1))
const _hoisted_121 = { class: "ui-produto-marca" }
const _hoisted_122 = {
  key: 0,
  class: "ui-produto-ja-adicionado"
}
const _hoisted_123 = { class: "ui-produto-acoes" }
const _hoisted_124 = { class: "ui-produto-imagem" }
const _hoisted_125 = ["onClick"]
const _hoisted_126 = {
  key: 2,
  class: "ui-item-content"
}
const _hoisted_127 = {
  key: 0,
  class: "ui-item-form"
}
const _hoisted_128 = { class: "ui-item-nome" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-item-imagem" }, null, -1))
const _hoisted_130 = { class: "ui-item-grid-cabecalho" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Código", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Preço Unitário", -1))
const _hoisted_133 = ["value"]
const _hoisted_134 = {
  style: {"display":"none"},
  class: "ui-ultima-compra"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-ultima-titulo" }, "ÚLTIMA COMPRA", -1))
const _hoisted_136 = { class: "ui-ultima-grid" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", null, "Data"),
  /*#__PURE__*/_createElementVNode("span", null, "-")
], -1))
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", null, "Quant."),
  /*#__PURE__*/_createElementVNode("span", null, "0")
], -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", null, "Valor"),
  /*#__PURE__*/_createElementVNode("span", null, "0")
], -1))
const _hoisted_140 = { class: "ui-digitacao-item" }
const _hoisted_141 = {
  style: {"display":"none"},
  class: "ui-item-linha"
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Valor Unitário R$:", -1))
const _hoisted_143 = ["disabled"]
const _hoisted_144 = {
  style: {"display":"none"},
  class: "ui-item-linha ui-desconto-item"
}
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Desconto %:", -1))
const _hoisted_146 = ["disabled"]
const _hoisted_147 = ["value"]
const _hoisted_148 = { class: "ui-item-linha" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Quantidade:", -1))
const _hoisted_150 = { class: "ui-quantidade-wrapper" }
const _hoisted_151 = ["disabled"]
const _hoisted_152 = {
  style: {"display":"none"},
  class: "ui-item-linha"
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Valor ST:", -1))
const _hoisted_154 = ["value"]
const _hoisted_155 = { class: "ui-item-linha ui-total-item" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Valor Total R$:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_combo_status_pedido = _resolveComponent("combo-status-pedido")!
  const _component_combo_forma_pagamento = _resolveComponent("combo-forma-pagamento")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "ui-toolbar-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.voltarTela && _ctx.voltarTela(...args)))
        }, [
          _createVNode(_component_icone, { nome: "voltar" })
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.tituloTela), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_tooltip, { title: "Salvar" }, {
            default: _withCtx(() => [
              ((_ctx.state.tela === 'dados-principais' && _ctx.pedidoEmDigitacao && _ctx.state.pedido.valorTotal > 0 && _ctx.state.alterouPedido))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ui-toolbar-btn",
                    style: {"margin-right":"20px"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salvarPedido && _ctx.salvarPedido(...args)))
                  }, [
                    _createVNode(_component_icone, {
                      style: {"font-size":"20px"},
                      nome: "salvar"
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tooltip, { title: "Enviar Pedido" }, {
            default: _withCtx(() => [
              ((_ctx.state.tela === 'dados-principais' && _ctx.pedidoEmDigitacao && _ctx.state.pedido.valorTotal > 0 && _ctx.state.pedido.codigo > 0 && !_ctx.state.alterouPedido))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ui-toolbar-btn",
                    style: {"margin-right":"20px"},
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.enviarPedido && _ctx.enviarPedido(...args)))
                  }, [
                    _createVNode(_component_icone, {
                      style: {"font-size":"20px"},
                      nome: "upload"
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tooltip, { title: "Excluir Pedido" }, {
            default: _withCtx(() => [
              ((_ctx.state.tela === 'dados-principais' && _ctx.state.pedido.codigo > 0 && _ctx.pedidoEmDigitacao))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ui-toolbar-btn",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deletarPedido && _ctx.deletarPedido(...args)))
                  }, [
                    _createVNode(_component_icone, {
                      style: {"font-size":"20px"},
                      nome: "excluir"
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tooltip, { title: "Salvar Item" }, {
            default: _withCtx(() => [
              (_ctx.state.tela === 'item' && _ctx.pedidoEmDigitacao)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ui-toolbar-btn",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirmarItem && _ctx.confirmarItem(...args)))
                  }, [
                    _createVNode(_component_icone, { nome: "salvar" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_a_form, {
        layout: "vertical",
        style: {"text-align":"left"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_skeleton, {
            loading: _ctx.appBase.carregando
          }, {
            default: _withCtx(() => [
              (_ctx.pedidoEmDigitacao && _ctx.state.recuperarSalvamentoAutomatico)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "warning",
                    "show-icon": "",
                    closable: ""
                  }, {
                    message: _withCtx(() => [
                      _createTextVNode(" Você possui uma versão mais recente deste pedido salvo de forma automática, deseja recuperar? "),
                      _createVNode(_component_a_button, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.recuperarSalvamentoAutomatico())),
                        size: "small",
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.tela === 'dados-principais')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({ 'ui-ativo': _ctx.state.aba === 'pedido' }),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.aba = 'pedido'))
                      }, " DADOS PRINCIPAIS ", 2),
                      (_ctx.apresentarAbaItens)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: _normalizeClass({ 'ui-ativo': _ctx.state.aba === 'itens' }),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.aba = 'itens'))
                          }, " ITENS DO PEDIDO ", 2))
                        : _createCommentVNode("", true),
                      (_ctx.apresentarAbaBuscarProdutos)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: _normalizeClass({ 'ui-ativo': _ctx.state.aba === 'buscarProdutos' }),
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.aba = 'buscarProdutos'))
                          }, " BUSCAR PRODUTOS ", 2))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.state.aba === 'pedido')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("input", {
                            type: "text",
                            class: "ui-input-pedido ui-input-cliente",
                            value: _ctx.clienteDescricao,
                            readonly: ""
                          }, null, 8, _hoisted_11),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _hoisted_14,
                              _createVNode(_component_a_input, {
                                value: _ctx.obtemNumeroIdentificacao(),
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.state.pedido.data,
                                "onUpdate:dataSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.pedido.data) = $event)),
                                disabled: ""
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createVNode(_component_combo_status_pedido, {
                                valor: _ctx.state.pedido.status,
                                "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.pedido.status) = $event)),
                                disabled: true
                              }, null, 8, ["valor"])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.cotacao) = $event)),
                                type: "checkbox",
                                class: "ui-checkbox-pedido",
                                onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                              }, null, 544), [
                                [_vModelCheckbox, _ctx.state.cotacao]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createVNode(_component_combo_forma_pagamento, {
                              codigo: _ctx.state.pedido.codigoFormaPagamento,
                              "onUpdate:codigo": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.pedido.codigoFormaPagamento) = $event)),
                              disabled: !_ctx.pedidoEmDigitacao,
                              onChange: _ctx.salvamentoAutomatico
                            }, null, 8, ["codigo", "disabled", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.tipoOperacao) = $event)),
                                class: "ui-input-pedido ui-select-pedido",
                                onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                              }, _hoisted_29, 544), [
                                [_vModelSelect, _ctx.state.tipoOperacao]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _hoisted_31,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.planoRecebimento) = $event)),
                                class: "ui-input-pedido ui-select-pedido",
                                onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                              }, _hoisted_36, 544), [
                                [_vModelSelect, _ctx.state.planoRecebimento]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.tabelaAjuste) = $event)),
                              class: "ui-input-pedido ui-select-pedido",
                              onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                            }, _hoisted_42, 544), [
                              [_vModelSelect, _ctx.state.tabelaAjuste]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _hoisted_44,
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.tipoRetirada) = $event)),
                              class: "ui-input-pedido ui-select-pedido",
                              onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                            }, _hoisted_47, 544), [
                              [_vModelSelect, _ctx.state.tipoRetirada]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _hoisted_49,
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.tipoFrete) = $event)),
                              class: "ui-input-pedido ui-select-pedido",
                              onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                            }, _hoisted_53, 544), [
                              [_vModelSelect, _ctx.state.tipoFrete]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _hoisted_55,
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.transportadora) = $event)),
                              class: "ui-input-pedido ui-select-pedido",
                              onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                            }, _hoisted_59, 544), [
                              [_vModelSelect, _ctx.state.transportadora]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _hoisted_61,
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.condicaoRecebimento) = $event)),
                              class: "ui-input-pedido ui-select-pedido",
                              onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                            }, _hoisted_65, 544), [
                              [_vModelSelect, _ctx.state.condicaoRecebimento]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _hoisted_67,
                            _createElementVNode("input", {
                              type: "text",
                              class: "ui-input-pedido",
                              onInput: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                            }, null, 32)
                          ]),
                          _createElementVNode("div", _hoisted_68, [
                            _hoisted_69,
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.pedido.observacoes) = $event)),
                              disabled: !_ctx.pedidoEmDigitacao,
                              class: "ui-input-pedido ui-textarea-pedido",
                              onInput: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.salvamentoAutomatico && _ctx.salvamentoAutomatico(...args)))
                            }, null, 40, _hoisted_70), [
                              [_vModelText, _ctx.state.pedido.observacoes]
                            ])
                          ]),
                          _hoisted_71,
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _hoisted_74,
                              _createElementVNode("strong", null, _toDisplayString(_ctx.totalItensQuantidade), 1)
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _hoisted_76,
                              _createElementVNode("strong", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.valorProdutos,2,true)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _hoisted_78,
                              _createElementVNode("div", _hoisted_79, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.percentualDesconto) = $event)),
                                  disabled: !_ctx.pedidoEmDigitacao,
                                  type: "number",
                                  class: "ui-input-total ui-pequeno",
                                  onInput: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.alterouPercentualDesconto && _ctx.alterouPercentualDesconto(...args)))
                                }, null, 40, _hoisted_80), [
                                  [
                                    _vModelText,
                                    _ctx.state.percentualDesconto,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _hoisted_81,
                                _createElementVNode("small", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.valorDesconto)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_82, [
                              _hoisted_83,
                              _createElementVNode("strong", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.pedido.valorAcrescimos)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_84, [
                              _hoisted_85,
                              _createElementVNode("strong", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.pedido.valorTotal,2,true)), 1)
                            ])
                          ])
                        ]))
                      : (_ctx.state.aba === 'itens')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.pedido.itens, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.codigoProdutoDefinicao,
                                  class: "ui-produto-card"
                                }, [
                                  _hoisted_88,
                                  _createElementVNode("div", {
                                    class: "ui-produto-info",
                                    onClick: ($event: any) => (_ctx.abrirItemPedido(item))
                                  }, [
                                    _createElementVNode("div", _hoisted_90, _toDisplayString(item.produto), 1),
                                    _createElementVNode("div", _hoisted_91, [
                                      _createElementVNode("div", null, [
                                        _hoisted_92,
                                        _createElementVNode("strong", null, _toDisplayString(item.sku), 1)
                                      ]),
                                      _createElementVNode("div", null, [
                                        _hoisted_93,
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.formatarQuantidade(item.quantidade)), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_94, [
                                      _createElementVNode("div", null, [
                                        _hoisted_95,
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(item.precoUnitario)), 1)
                                      ]),
                                      _createElementVNode("div", null, [
                                        _hoisted_96,
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(item.valorTotal)), 1)
                                      ])
                                    ])
                                  ], 8, _hoisted_89),
                                  (_ctx.pedidoEmDigitacao)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "ui-btn-produto-remover",
                                          onClick: _withModifiers(($event: any) => (_ctx.removerItemPedido(item)), ["stop"])
                                        }, " × ", 8, _hoisted_98)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_99, [
                              _createElementVNode("div", _hoisted_100, [
                                _hoisted_101,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.totalItensQuantidade), 1)
                              ]),
                              _createElementVNode("div", _hoisted_102, [
                                _hoisted_103,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.valorProdutos,2,true)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_104, [
                                _hoisted_105,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.pedido.valorTotal,2,true)), 1)
                              ])
                            ])
                          ]))
                        : (_ctx.state.aba === 'buscarProdutos')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                              _createElementVNode("div", _hoisted_107, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", _hoisted_108, [
                                    _createElementVNode("span", _hoisted_109, [
                                      _createElementVNode("span", _hoisted_110, [
                                        _createVNode(_component_icone, { nome: "pesquisar" })
                                      ])
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.parametrosBuscaProduto.valorPesquisa) = $event)),
                                      placeholder: "Digite o nome ou código para encontrar os produtos",
                                      type: "text",
                                      class: "ant-input",
                                      onInput: _cache[34] || (_cache[34] = ($event: any) => (_ctx.buscarProdutos()))
                                    }, null, 544), [
                                      [_vModelText, _ctx.state.parametrosBuscaProduto.valorPesquisa]
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_111, [
                                (!_ctx.state.produtosBusca.length)
                                  ? (_openBlock(), _createBlock(_component_a_empty, {
                                      key: 0,
                                      description: "Nenhum produto encontrado"
                                    }))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.produtosBusca, (produto) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: produto.codigoProdutoDefinicao,
                                    class: _normalizeClass(["ui-produto-card", { 'ui-produto-card-adicionado': _ctx.produtoJaAdicionado(produto.codigoProdutoDefinicao) }])
                                  }, [
                                    _hoisted_112,
                                    _createElementVNode("div", _hoisted_113, [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (_ctx.abrirItem(produto)),
                                        class: "ui-produto-nome"
                                      }, _toDisplayString(produto.nomeProduto), 9, _hoisted_114),
                                      _createElementVNode("div", _hoisted_115, [
                                        _createElementVNode("div", null, [
                                          _hoisted_116,
                                          _createElementVNode("strong", _hoisted_117, _toDisplayString(_ctx.formatarQuantidade(produto.quantidadeEstoque)), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_118, [
                                        _createElementVNode("div", null, [
                                          _hoisted_119,
                                          _createElementVNode("strong", null, _toDisplayString(produto.sku), 1)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _hoisted_120,
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(produto.precoUnitario)), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_121, [
                                        _createTextVNode(" Marca: "),
                                        _createElementVNode("strong", null, _toDisplayString(produto.marca), 1)
                                      ]),
                                      (_ctx.produtoJaAdicionado(produto.codigoProdutoDefinicao))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_122, " Produto já está no pedido. "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_123, [
                                      _createElementVNode("div", _hoisted_124, [
                                        (produto.imagem)
                                          ? (_openBlock(), _createBlock(_component_a_image, {
                                              key: 0,
                                              width: "30",
                                              src: produto.imagem,
                                              preview: { src: produto.imagem },
                                              onClick: _cache[35] || (_cache[35] = _withModifiers(() => {}, ["stop"]))
                                            }, null, 8, ["src", "preview"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (!_ctx.produtoJaAdicionado(produto.codigoProdutoDefinicao))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "ui-btn-produto-adicionar",
                                            onClick: ($event: any) => (_ctx.abrirItem(produto))
                                          }, " + ", 8, _hoisted_125))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 2))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_126, [
                    (_ctx.state.produtoSelecionado)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                          _createElementVNode("div", _hoisted_128, [
                            _createTextVNode(_toDisplayString(_ctx.state.produtoSelecionado.nomeProduto) + " ", 1),
                            _hoisted_129
                          ]),
                          _createElementVNode("div", _hoisted_130, [
                            _createElementVNode("div", null, [
                              _hoisted_131,
                              _createElementVNode("strong", null, _toDisplayString(_ctx.state.produtoSelecionado.sku), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_132,
                              _createElementVNode("input", {
                                value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.produtoSelecionado.precoUnitario, 2, true),
                                type: "text",
                                class: "ui-input-preco-unitario",
                                readonly: ""
                              }, null, 8, _hoisted_133)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_134, [
                            _hoisted_135,
                            _createElementVNode("div", _hoisted_136, [
                              _hoisted_137,
                              _hoisted_138,
                              _hoisted_139,
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ui-btn-repete",
                                  onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.repetirUltimaCompra && _ctx.repetirUltimaCompra(...args)))
                                }, " REPETE ")
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_140, [
                            _createElementVNode("div", _hoisted_141, [
                              _hoisted_142,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.item.valorUnitario) = $event)),
                                disabled: !_ctx.pedidoEmDigitacao,
                                type: "number",
                                class: "ui-input-item",
                                onInput: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.alterouItem && _ctx.alterouItem(...args)))
                              }, null, 40, _hoisted_143), [
                                [
                                  _vModelText,
                                  _ctx.state.item.valorUnitario,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_144, [
                              _hoisted_145,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.item.percentualDesconto) = $event)),
                                disabled: !_ctx.pedidoEmDigitacao,
                                type: "number",
                                class: "ui-input-item ui-pequeno",
                                onInput: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.alterouItem && _ctx.alterouItem(...args)))
                              }, null, 40, _hoisted_146), [
                                [
                                  _vModelText,
                                  _ctx.state.item.percentualDesconto,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("input", {
                                value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.valorDesconto),
                                type: "text",
                                class: "ui-input-item ui-pequeno",
                                readonly: ""
                              }, null, 8, _hoisted_147)
                            ]),
                            _createElementVNode("div", _hoisted_148, [
                              _hoisted_149,
                              _createElementVNode("div", _hoisted_150, [
                                (_ctx.pedidoEmDigitacao)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.diminuirQuantidade && _ctx.diminuirQuantidade(...args))),
                                      type: "button",
                                      class: "ui-diminuir"
                                    }, " - "))
                                  : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("input", {
                                  title: "Quantidade",
                                  type: "number",
                                  min: "1",
                                  max: "99999",
                                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.item.quantidade) = $event)),
                                  disabled: !_ctx.pedidoEmDigitacao,
                                  placeholder: "Quantidade",
                                  onInput: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.alterouQuantidade && _ctx.alterouQuantidade(...args)))
                                }, null, 40, _hoisted_151), [
                                  [_vModelText, _ctx.state.item.quantidade]
                                ]),
                                (_ctx.pedidoEmDigitacao)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.aumentarQuantidade && _ctx.aumentarQuantidade(...args))),
                                      type: "button",
                                      class: "ui-aumentar"
                                    }, " + "))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_152, [
                              _hoisted_153,
                              _createElementVNode("input", {
                                value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.valorSt),
                                type: "text",
                                class: "ui-input-item",
                                readonly: ""
                              }, null, 8, _hoisted_154)
                            ]),
                            _createElementVNode("div", _hoisted_155, [
                              _hoisted_156,
                              _createElementVNode("strong", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.item.valorTotal)), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}